<template>
  <div>
    <alert ref="courseUserModalAlert" :body="alert.message" :type="alert.type" />
    <div
      class="modal fade"
      id="detailsCourseUserModal"
      tabindex="-1"
      aria-labelledby="detailsCourseUserModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="detailsCourseUserModalLabel">
              Course - User
              <small class="text-muted">Details</small>
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click.prevent="close()"></button>
          </div>
          <div class="modal-body">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <button
                  class="nav-link active"
                  id="nav-settings-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-settings"
                  type="button"
                  role="tab"
                  aria-controls="nav-settings"
                  aria-selected="true"
                >
                  User Settings
                </button>
                <button
                  class="nav-link"
                  id="nav-exams-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-exams"
                  type="button"
                  role="tab"
                  aria-controls="nav-exams"
                  aria-selected="false"
                >
                  Exams
                </button>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent" style="padding: 15px">
              <div
                class="tab-pane fade show active"
                id="nav-settings"
                role="tabpanel"
                aria-labelledby="nav-settings-tab"
                tabindex="0"
              >
                <div class="row">
                  <div class="mt-2 col-12">
                    <strong>Full Name:</strong>
                    {{ activeCourseUser.userFullName }}
                  </div>
                  <div class="mt-2 col-12">
                    <strong>Email:</strong>
                    {{ activeCourseUser.userEmailAddress }}
                  </div>

                  <hr class="mt-2" />

                  <div class="mt-2 col-6 col-md-3">
                    <strong>Joined In:</strong>
                    <input type="date" class="form-control" :value="formatDate(activeCourseUser?.createdDate)" disabled />
                  </div>
                  <div class="mt-2 col-6 col-md-3">
                    <strong>Finish In:</strong>
                    <input
                      type="date"
                      class="form-control"
                      :min="formatDate(activeCourseUser?.createdDate)"
                      :value="formatDate(activeCourseUser?.finishedDate)"
                      @change="confirmChangeFinished"
                    />
                  </div>

                  <div class="mt-2 col-12">
                    <strong>User Status:</strong>
                    <div class="form-check form-switch" style="transform: scale(1.25); transform-origin: left">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="userStatus"
                        :checked="activeCourseUser.active"
                        @change="confirmChangeStatus"
                      />
                      <label class="form-check-label" for="userStatus">Active</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade" id="nav-exams" role="tabpanel" aria-labelledby="nav-exams-tab" tabindex="0">
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 35%">Name</th>
                      <th scope="col" style="width: 20%">Grade for pass</th>
                      <th scope="col" style="width: 20%">Grade</th>
                      <th scope="col" style="width: 20%">Approved</th>
                      <th scope="col" style="width: 5%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="exam of activeCourseUser.exams">
                      <td>{{ exam.name }}</td>
                      <td>
                        <span>{{ exam.gradeToPass }}</span>
                      </td>
                      <td>
                        <span v-if="!exam.active">{{ exam.grade }}</span>
                      </td>
                      <td>
                        <template v-if="!exam.active">
                          <span class="text-success" v-if="exam.approved">
                            <i class="fa-solid fa-check"></i>
                          </span>
                          <span class="text-danger" v-else>
                            <i class="fa-solid fa-xmark"></i>
                          </span>
                        </template>
                      </td>
                      <td>
                        <template v-if="!exam.active">
                          <a
                            :href="`/course/view/${activeCourseUser.courseId}/${exam.contentId}?exam=${exam.examId}`"
                            class="btn btn-link btn-sm"
                            title="show exam deatils"
                          >
                            <i class="fas fa-eye"></i>
                          </a>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vuex from 'vuex';
  import request from '../../../../helpers/request';
  import { Modal } from 'bootstrap';
  import moment from 'moment';
  import alert from '../../../utilities/alert';

  export default {
    name: 'CourseUserModal',
    components: {
      alert,
    },
    computed: {
      ...Vuex.mapState({ authToken: state => state.auth.token }),
    },
    methods: {
      openAlert(msg, type, timeOut = 0) {
        return new Promise((resolve, reject) => {
          this.alert.message = msg;
          this.alert.type = type;
          this.$refs['courseUserModalAlert'].open();
          setTimeout(() => {
            this.$refs['courseUserModalAlert'].close();
            resolve(true);
          }, timeOut);
        });
      },

      formatDate(date = null) {
        return date ? moment(date).format('YYYY-MM-DD') : null;
      },

      open(courseUser) {
        if (!courseUser) return;
        this.activeCourseUser = courseUser;
        this.detailsCourseUserModal.show();
        this.$emit('open', courseUser);
      },

      close() {
        this.detailsCourseUserModal.hide();
        this.activeCourseUser = { exams: [] };
        this.$emit('close');
      },

      async confirmChangeFinished(event) {
        const newValue = event.target.value;
        if (confirm(`Are you sure you want to set the finished date to ${newValue}?`)) {
          await this.updateCourseUser(this.activeCourseUser._id, { finishedDate: newValue });
          this.activeCourseUser.finishedDate = moment(newValue).format('YYYY/MM/DD HH:mm:ss');
          this.openAlert(`Date of finished subscription updated succesfully`, 'success', 1500);
        } else {
          event.target.value = this.formatDate(this.activeCourseUser.finishedDate);
        }
      },

      async confirmChangeStatus(event) {
        const newValue = event.target.checked;
        if (confirm(`Are you sure you want to ${newValue ? 'enable' : 'disable'} this user for the course?`)) {
          await this.updateCourseUser(this.activeCourseUser._id, { active: newValue });
          this.activeCourseUser.active = newValue;
          this.openAlert(`${newValue ? 'Enabled' : 'Disabled'} user succesfully`, 'success', 1500);
        } else {
          event.target.checked = this.activeCourseUser.active;
        }
      },

      async updateCourseUser(courseUserId, data) {
        try {
          await request(
            'POST',
            '/course/user/update',
            {
              courseUserId: courseUserId,
              ...data,
            },
            this.authToken
          );
        } catch (error) {
          this.openAlert('Error: ', error, 'danger', 5500);
        }
      },
    },
    mounted() {
      this.detailsCourseUserModal = new Modal(document.getElementById('detailsCourseUserModal'));
    },
    data() {
      return {
        activeCourseUser: { exams: [] },
        detailsCourseUserModal: null,
        alert: {
          message: null,
          type: null,
        },
      };
    },
  };
</script>
